import { z } from "zod";

/*
 * Strapi Client is quite shit, not exporting types, not handling generics, ...
 *
 * Here is a copy of [strapi-content-api-types]()
 */

/* Custom Types
 * -------------------------------------------------------------------------- */

export type DocumentMeta = z.output<typeof DocumentMetaTs>;

export type OmitDocumentMeta = keyof DocumentMeta;

export type AnyDocumentData = {
  [key: string]: any;
};


//export const DateTimeTs = (
//z.string()
//.transform(dateString => new Date(dateString))
//);


//export const DocumentMetaTs = z.object({
//documentId: z.string(),
//createdAt: DateTimeTs,
//updatedAt: DateTimeTs,
//}) satisfies z.ZodType<
//{ documentId: string; createdAt: Date; updatedAt: Date },
//Pick<Document, "documentId" | "createdAt" | "updatedAt">
//>;


export const DocumentMetaTs = z.object({
  documentId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
}) satisfies z.ZodType<
  Pick<Document, "documentId" | "createdAt" | "updatedAt">
>;


export const ResponseTs = z.object({
  meta: z.object({
    pagination: z.looseObject({
      page: z.int().optional(),
      pageSize: z.int().optional(),
      pageCount: z.int().optional(),
      total: z.int().optional(),
    }).optional(),
  }).optional(),
});//satisfies z.ZodType<{ meta: ResponseMeta }>;


export const FileTs = z.object({
  id: z.int(),
  documentId: z.string(),
  name: z.string(),
  alternativeText: z.string().optional(),
  caption: z.string().optional(),
  width: z.number(),
  height: z.number(),
  hash: z.string(),
  ext: z.string(),
  mime: z.string(),
  url: z.string(),
  size: z.number(),
  provider: z.string(),
  previewUrl: z.string().nullable(),
  provider_metadata: z.any().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  formats: z.any().optional(),
  folderPath: z.string().optional(),
}) satisfies z.ZodType<FileResponse>;


/* Original Strapi Content Types [content-api-types](https://github.com/strapi/client/blob/main/src/types/content-api.ts)
 * -------------------------------------------------------------------------- */

/*
 * Strapi Client is quite shit, not exporting types, not handling generics, ...
 *
 * Here is a copy of [strapi-content-api-types](https://github.com/strapi/client/blob/main/src/types/content-api.ts)
 */

export interface Document {
  documentId: string;
  createdAt: string;
  updatedAt: string;
  [key: string]: any;
}

export interface Pagination {
  // page: number;
  // pageSize: number;
  // pageCount: number;
  // total: number;
}

export interface ResponseMeta {
  pagination?: Pagination;
}

export interface DocumentResponse<T extends Document = Document> {
  data: T;
  meta: ResponseMeta;
}

export interface DocumentResponseCollection<T extends Document = Document> {
  data: T[];
  meta: ResponseMeta;
}

/**
 * Defines the structure of query parameters supported for Strapi content API requests.
 *
 * It provides options for filtering, sorting, pagination, localization, and population of related fields.
 *
 * @example
 * Fetching articles with filters, pagination, and specific fields.
 * ```typescript
 * const queryParams: baseQueryParams = {
 *   filters: { category: 'tech' }, // Filters articles by a 'tech' category
 *   fields: ['title', 'author'], // Fetches only 'title' and 'author' fields
 *   pagination: { page: 1, pageSize: 10 }, // Retrieves the first page with 10 items
 *   sort: ['publishedAt:desc'], // Sorts by 'publishedAt' field in descending order
 *   populate: { comments: true }, // Populates the 'comments' field with related data
 *   locale: 'en', // Fetches content available in English
 *   status: 'published' // Retrieves only published documents
 * };
 *
 * const articles = await collectionManager.find(queryParams);
 * ```
 *
 * @example
 * Appending query parameters to a URL
 * ```typescript
 * const url = 'https://api.example.com/articles';
 *
 * const params: BaseQueryParams = {
 *   filters: { isFeatured: true }, // Filters featured articles
 *   sort: 'title', // Sorts articles alphabetically by title
 * };
 *
 * const fullUrl = URLHelper.appendQueryParams(url, params);
 * // fullUrl: 'https://api.example.com/articles?filters[isFeatured]=true&sort=title'
 * ```
 *
 * @see {@link URLHelper.appendQueryParams} for how this type is serialized into query strings for API endpoints.
 */
export interface BaseQueryParams {
  /**
   * Specifies related fields or relations to return.
   *
   * Can be:
   * - a `string` to specify relation paths as `populate=name`
   * - an `array` of strings to specify multiple relation paths
   * - an `object` to enable deeper population configurations
   */
  populate?: string | string[] | Record<string, unknown>;

  /**
   * Specifies the fields of documents to include in the response.
   *
   * @note `documentId` and `id` fields are always present in a document, regardless of manually selected fields.
   */
  fields?: string[];

  /**
   * Applies filters to the records based on field values.
   */
  filters?: Record<string, unknown>;

  /**
   * Specifies the locale of the content to fetch.
   *
   * Relevant only for content types with i18n localization enabled.
   *
   * @example
   * // Retrieving content in German:
   * locale: 'de'
   */
  locale?: string;

  /**
   * Specifies the publication status of the content to fetch.
   * - `'draft'`: fetches only draft records.
   * - `'published'`: fetches only published records.
   */
  status?: 'draft' | 'published';

  /**
   * Sort the results based on a specific order.
   *
   * Can be
   * - a single string like `'field:asc'`
   * - an array of strings for multiple sorting criteria.
   */
  sort?: string | string[];

  /**
   * Configures pagination options for requests.
   *
   * Supports two combinations:
   * - `page` and `pageSize`: specify the pagination page and its size.
   * - `start` and `limit`: specify the starting index and the number of records to fetch.
   *
   * If `withCount` is set to true, include the total count of matched records in the response.
   */
  pagination?: {
    page?: number;
    pageSize?: number;
    withCount?: boolean;
    start?: number;
    limit?: number;
  };
}


/* Original Strapi File Types [src](https://github.com/strapi/client/blob/main/src/files/types.ts)
 * -------------------------------------------------------------------------- */

/**
 * Parameters for querying files in the Strapi upload plugin.
 *
 * Note: The upload plugin uses a different API structure than the content API
 * and doesn't support the standard pagination parameters.
 */
export interface FileQueryParams {
  /**
   * Filters to apply to the query.
   * Example: { name: { $contains: 'example' } }
   */
  filters?: Record<string, any>;

  /**
   * Sorting criteria for the query.
   * Example: ['name:asc'] or 'name:asc'
   */
  sort?: string | string[];
}

/**
 * Interface defining the fields that can be updated for a file.
 */
export interface FileUpdateData {
  name?: string;
  alternativeText?: string;
  caption?: string;
}

/**
 * Response structure for a single file from the Strapi upload plugin.
 * This interface represents the actual response structure from the API.
 */
export interface FileResponse {
  id: number;
  documentId: string;
  name: string;
  alternativeText?: string;
  caption?: string;
  width: number;
  height: number;
  hash: string;
  ext: string;
  mime: string;
  url: string;
  size: number;
  provider: string;
  previewUrl: string | null;
  provider_metadata?: any;
  createdAt: string;
  updatedAt: string;
  formats?: any;
  folderPath?: string;
}

/**
 * Response structure for a list of files.
 *
 * Note: Unlike the core content API, the upload plugin returns a flat array of files
 * without the data/meta structure used in the core content API responses.
 */
export type FileListResponse = Array<FileResponse>;
